import { StyleSheet, Platform } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  codeInputText: {
    borderRadius: 6.2,
    color: Colors.dark_grey,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    height: 60,
    lineHeight: 25,
    marginBottom: 32,
    marginTop: 32,
    width: 60,
  },
  container: {
    height: null,
  },
  error: {
    marginTop: 20,
  },
  icon: {
    marginRight: 5,
  },
  label: {
    alignSelf: 'center',
    marginBottom: 30,
  },
  loadingContainer: {
    alignItems: 'center',
    alignSelf: 'center',
    flexDirection: 'row',
    marginBottom: 30,
  },
  loadingText: {
    color: Colors.dark_grey,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    lineHeight: 31.2,
    paddingTop: Platform.OS === 'ios' ? 3 : null,
  },
  textLabel: {
    color: Colors.light_grey,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    lineHeight: 22.9,
    textDecorationLine: 'underline',
  },
})
